import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-success-page',
  templateUrl: './payment-success-page.component.html',
  styleUrls: ['./payment-success-page.component.scss'],
})
export class PaymentSuccessPageComponent {
  constructor() {}
}
